import { StorageValue } from "zustand/middleware";

export const deserializeStore = <T>(
  str: string | null,
): { state: T } | null => {
  if (!str) return null;

  const { state } = JSON.parse(str);

  return {
    state: { ...state },
  };
};

export const serializeStore = <T>(value: StorageValue<T>) =>
  JSON.stringify(value);
